<div class="table-controls">
  <!-- <div class="filter-button">
        <i class="bi bi-filter"></i>
    </div> -->

  <div
    ngbDropdown
    class="d-inline-block"
    [autoClose]="'outside'"
    (openChange)="onDropdownClose($event)"
  >
    <div
      class="filter-button"
      [class.active]="hasAnyFiltersApplied()"
      ngbDropdownToggle
    >
      <i class="bi bi-filter"></i>
      Filter
    </div>

    <div ngbDropdownMenu>
      <div class="filter-dropdown-menu">
        <div class="filter-menu-header">
          <h5 class="dropdown-title">Filters</h5>

          <button
            class="btn btn-outline-primary btn-sm"
            (click)="clearFilters()"
          >
            Clear Filters
          </button>
        </div>

        <input
          inputmode="search"
          role="searchbox"
          type="search"
          name="search"
          class="form-control filter-search"
          placeholder="Search filters..."
          [(ngModel)]="filterSearch"
        />

        <div
          class="filter-category"
          *ngFor="let filter of getFilteredFilters()"
          [class.active]="
            activeSubFilter === filter.key ||
            hasSelectedFilterOption(filter.key)
          "
          (click)="setActiveSubFilter(filter.key, filterItem)"
          #filterItem
        >
          {{ filter.label }}
          <i class="bi bi-chevron-right float-end"></i>
        </div>
      </div>

      <div
        class="sub-filter-dropdown"
        *ngIf="activeSubFilter"
        [style.top.px]="subFilterTopOffset"
      >
        <h6>{{ getFilterLabel(activeSubFilter) }}</h6>

        <div
          class="option"
          *ngFor="let option of getSubFilterOptions(activeSubFilter)"
          [class.selected]="isSelectedFilterOption(activeSubFilter, option)"
          [ngClass]="{
            'wide-option':
              activeSubFilter === 'recipients' ||
              activeSubFilter === 'bsa' ||
              activeSubFilter === 'bmi',
          }"
          (click)="toggleFilterOption(activeSubFilter, option)"
          [innerHTML]="option"
        ></div>

        <div class="sub-filter-actions mt-2">
          <button class="btn btn-link" (click)="resetFilter(activeSubFilter)">
            Reset
          </button>
          <button class="btn btn-primary btn-sm" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>

    <!-- Sub Filter Menu -->
  </div>

  <button
    *ngIf="isRecipientWithRecommendationsSelected()"
    class="bestmatch-button"
    [class.active]="isSortByRecommendationApplied"
    (click)="sortByBestMatch()"
  >
    <i class="bi bi-magic"></i>
    Sort by Recommended
  </button>

  <input
    inputmode="search"
    role="searchbox"
    type="search"
    name="search"
    class="search-box"
    placeholder="Search..."
    [(ngModel)]="searchQuery"
    (input)="searchDonors()"
  />
  <div class="form-check ms-3 m-auto pb-3">
    <input
      class="form-check-input"
      type="checkbox"
      id="toggleExpandedMetrics"
      [(ngModel)]="showExpandedMetrics"
      (change)="checkIfScrollable()"
    />
    <label class="form-check-label" for="toggleExpandedMetrics">
      Expand Key Metrics
    </label>
  </div>
</div>

<div class="table-container">
  @if (isLoadingDonors) {
    <div class="spinner-container">
      <div class="spinner"></div>
      <span>Refreshing Donors…</span>
    </div>
  } @else if (isLoadingRecommendations) {
    <div class="spinner-container">
      <div class="spinner"></div>
      <span>Optimizing match scores. This may take a moment…</span>
    </div>
  } @else if (isBulkMetricsLoading) {
    <div class="spinner-container">
      <div class="spinner"></div>
      <span>Loading donor metrics…</span>
    </div>
  } @else if (filteredDonors.length === 0) {
    <div class="no-results-message">
      No donors found matching your current filters or search criteria.
    </div>
  } @else {
    <div class="desktop-table-view">
      <div class="scroll-container">
      <button
        class="scroll-indicator"
        *ngIf="isContentScrollable"
        (click)="scrollRight()"
        aria-label="Scroll right"
      >
        <i class="bi bi-chevron-right"></i>
      </button>
        <div class="horizontal-scroll-wrapper" #scrollWrapper>
          <table class="donor-table">
          <thead>
            <tr>
              <th (click)="sortByDonor()">
                <div class="sortable-header">
                  Donor
                  <i
                    *ngIf="sortedField === 'donor'"
                    class="bi"
                    [ngClass]="
                      donorSortDirection === 'asc'
                        ? 'bi-arrow-up'
                        : 'bi-arrow-down'
                    "
                  ></i>
                </div>
              </th>
              <th (click)="sortByRecipient()">
                <div class="sortable-header">
                  Recipient
                  <i
                    *ngIf="sortedField === 'recipient'"
                    class="bi"
                    [ngClass]="
                      recipientSortDirection === 'asc'
                        ? 'bi-arrow-up'
                        : 'bi-arrow-down'
                    "
                  ></i>
                </div>
              </th>
              <th (click)="sortByStepsCompleted()">
                <div class="sortable-header">
                  Evaluation Step
                  <i
                    *ngIf="sortedField === 'stepsCompleted'"
                    class="bi"
                    [ngClass]="
                      progressSortDirection === 'asc'
                        ? 'bi-arrow-up'
                        : 'bi-arrow-down'
                    "
                  ></i>
                </div>
              </th>
              @if (!showExpandedMetrics) {
                <th>Donor Key Metrics</th>
              } @else {
                <th
                  *ngFor="let key of expandedMetricKeys"
                  (click)="sortByExpandedMetric(key)"
                  [class.motivation-level-col]="key === 'Motivation Level'"
                  [class.metric-age-col]="key === 'Age'"
                  [class.metric-recipient-age-col]="key === 'Recipient Age'"
                  [class.metric-gender-col]="key === 'Gender'"
                  [class.metric-eligibility-col]="key === 'Eligibility Status'"
                >
                  <div class="sortable-header">
                    {{ key }}
                    <i
                      *ngIf="sortedField === key"
                      class="bi"
                      [ngClass]="
                        expandedSortDirection === 'asc'
                          ? 'bi-arrow-up'
                          : 'bi-arrow-down'
                      "
                    ></i>
                  </div>
                </th>
              }
              <th (click)="sortByAssignedTo()">
                <div class="sortable-header">
                  Assigned To
                  <i
                    *ngIf="sortedField === 'assignedTo'"
                    class="bi"
                    [ngClass]="
                      assignedSortDirection === 'asc'
                        ? 'bi-arrow-up'
                        : 'bi-arrow-down'
                    "
                  ></i>
                </div>
              </th>
              @if (this.isAdmin()) {
                <th>Actions</th>
              }
            </tr>
          </thead>

          <tbody>
            @for (donor of paginatedDonors; track donor) {
              <tr
                [ngClass]="[
                  isSortByRecommendationApplied &&
                  recommendationScores.get(donor?.email ?? '') !== -1000
                    ? 'recommended-donor'
                    : '',
                  isSortByRecommendationApplied &&
                  recommendationScores.get(donor?.email ?? '') === -1000
                    ? 'non-recommended-donor'
                    : '',
                  isSortByRecommendationApplied &&
                  recommendationScores.has(donor?.email ?? '') &&
                  recommendationScores.get(donor?.email ?? '')! >= 0
                    ? 'recommendation-rank-' +
                      (filteredDonors.indexOf(donor) + 1)
                    : '',
                ]"
              >
                <td
                  class="donor-info-col"
                  (click)="navigateToDonorJourney(donor)"
                >
                  <div class="donor-info-container">
                    <img
                      src="placeholder_profile.png"
                      alt="profile picture"
                      class="avatar"
                    />
                    <div class="donor-info">
                      <p class="name">
                        {{ donor.firstName }} {{ donor.lastName }}
                      </p>
                      <p class="email">{{ donor.email }}</p>
                    </div>
                  </div>
                </td>
                <td class="recipient-col">
                  <span class="recipient-name">{{
                    getRecipientNameMetric(donor.metrics)
                  }}</span>
                </td>

                <td class="progress-col">
                  <div class="progress-container">
                    <div class="progress-bar-wrapper">
                      <div
                        class="progress-bar"
                        [ngClass]="getProgressColor(donor.progress)"
                        [style.width]="donor.progress"
                      >
                        <span class="progress-label">
                          {{ donor.completedSections }}/{{
                            donor.totalSections
                          }}
                        </span>
                      </div>
                    </div>
                    <span class="progress-text">{{
                      donor.dashboardStatus
                    }}</span>
                  </div>
                </td>
                <!-- <td>
            <div>
              <span>
                {{ donor.dashboardStatus }}
              </span>
            </div>
          </td> -->
                <ng-container *ngIf="!showExpandedMetrics">
                  <td class="metrics-col">
                    @if (isMetricsLoading(donor)) {
                      <span class="metrics-loading">Loading metrics…</span>
                    } @else {
                      <div class="metrics-container">
                        <span
                          class="metrics-pill"
                          *ngFor="
                            let metric of getDisplayableMetrics(donor.metrics, donor)
                          "
                          [ngClass]="[
                            getMetricColorClass(donor, metric.key),
                            getRecommendationColorClass(donor, metric.key),
                          ]"
                        >
                          <span>{{ metric.key }} - {{ metric.value }}</span>
                          @if (metric.translated) {
                            <i
                              class="bi bi-translate translated-metric-icon"
                              ngbTooltip="Translated to English"
                              placement="top"
                              container="body"
                              aria-label="Translated to English"
                            ></i>
                          }
                        </span>
                        @if (isSpanishDonor(donor)) {
                          <span class="metrics-pill language-metric-pill">
                            Language - ES
                          </span>
                        }
                      </div>
                    }
                  </td>
                </ng-container>
                <ng-container *ngIf="showExpandedMetrics">
                  <td
                    *ngFor="let key of expandedMetricKeys"
                    [ngClass]="getRecommendationColorClass(donor, key)"
                    [class.motivation-level-col]="key === 'Motivation Level'"
                    [class.metric-age-col]="key === 'Age'"
                    [class.metric-recipient-age-col]="key === 'Recipient Age'"
                    [class.metric-gender-col]="key === 'Gender'"
                    [class.metric-eligibility-col]="key === 'Eligibility Status'"
                  >
                    @if (isMetricsLoading(donor)) {
                      <span class="metrics-loading">Loading…</span>
                    } @else {
                      {{ getMetricValue(donor.metrics, key) }}
                    }
                  </td>
                </ng-container>
                <td class="assigned-to-cell">
                  <div
                    class="assigned-to-container"
                    ngbDropdown
                    #dropdown="ngbDropdown"
                  >
                    <button
                      class="assigned-to-pill"
                      ngbDropdownToggle
                      (mouseover)="hoveredDonor = donor.email"
                      (mouseleave)="hoveredDonor = null"
                    >
                      <span class="assigned-to-text">
                        {{ getAssignedToDisplayName(donor.assignedTo) }}
                      </span>
                      <i
                        *ngIf="hoveredDonor === donor.email"
                        class="bi bi-pencil"
                      ></i>
                    </button>

                    <!-- NgbDropdown Menu -->
                    <div ngbDropdownMenu class="dropdown-menu">
                      <button
                        class="dropdown-item"
                        *ngFor="let admin of admins"
                        (click)="assignTo(donor, admin); dropdown.close()"
                      >
                        {{ admin.firstName }} {{ admin.lastName }}
                      </button>
                    </div>
                  </div>
                </td>
                @if (this.isAdmin()) {
                  <td>
                    <button
                      class="icon-button"
                      (click)="openDonorProfileAdminActions(donor)"
                    >
                      <i class="bi bi-info-circle"></i>
                    </button>
                  </td>
                }
              </tr>
            }
          </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mobile-cards-view">
      <div class="mobile-donor-cards">
        @for (donor of paginatedDonors; track donor) {
          <article
            class="donor-card"
            [ngClass]="[
              isSortByRecommendationApplied &&
              recommendationScores.get(donor?.email ?? '') !== -1000
                ? 'recommended-donor'
                : '',
              isSortByRecommendationApplied &&
              recommendationScores.get(donor?.email ?? '') === -1000
                ? 'non-recommended-donor'
                : '',
            ]"
          >
            <div class="donor-card-header" (click)="navigateToDonorJourney(donor)">
              <img
                src="placeholder_profile.png"
                alt="profile picture"
                class="avatar"
              />
              <div class="donor-card-header-text">
                <p class="name">{{ donor.firstName }} {{ donor.lastName }}</p>
                <p class="email">{{ donor.email }}</p>
              </div>
            </div>

            <div class="donor-card-row">
              <span class="donor-card-label">Recipient</span>
              <span class="donor-card-value recipient-name">
                {{ getRecipientNameMetric(donor.metrics) }}
              </span>
            </div>

            <div class="donor-card-row">
              <span class="donor-card-label">Evaluation Step</span>
              <div class="progress-container">
                <div class="progress-bar-wrapper">
                  <div
                    class="progress-bar"
                    [ngClass]="getProgressColor(donor.progress)"
                    [style.width]="donor.progress"
                  >
                    <span class="progress-label">
                      {{ donor.completedSections }}/{{ donor.totalSections }}
                    </span>
                  </div>
                </div>
                <span class="progress-text">{{ donor.dashboardStatus }}</span>
              </div>
            </div>

            <div class="donor-card-row donor-card-metrics">
              <span class="donor-card-label">Key Metrics</span>
              @if (isMetricsLoading(donor)) {
                <span class="metrics-loading">Loading metrics…</span>
              } @else {
                <div class="metrics-container">
                  <span
                    class="metrics-pill"
                    *ngFor="let metric of getDisplayableMetrics(donor.metrics, donor)"
                    [ngClass]="[
                      getMetricColorClass(donor, metric.key),
                      getRecommendationColorClass(donor, metric.key),
                    ]"
                  >
                    <span>{{ metric.key }} - {{ metric.value }}</span>
                    @if (metric.translated) {
                      <i
                        class="bi bi-translate translated-metric-icon"
                        ngbTooltip="Translated to English"
                        placement="top"
                        container="body"
                        aria-label="Translated to English"
                      ></i>
                    }
                  </span>
                  @if (isSpanishDonor(donor)) {
                    <span class="metrics-pill language-metric-pill">
                      Language - ES
                    </span>
                  }
                </div>
              }
            </div>

            <div class="donor-card-row">
              <span class="donor-card-label">Assigned To</span>
              <span class="donor-card-value">
                {{ getAssignedToDisplayName(donor.assignedTo) }}
              </span>
            </div>

            <div class="donor-card-actions">
              <button class="mobile-action-button" (click)="navigateToDonorJourney(donor)">
                View Journey
              </button>
              @if (this.isAdmin()) {
                <button
                  class="icon-button mobile-icon-button"
                  (click)="openDonorProfileAdminActions(donor)"
                >
                  <i class="bi bi-info-circle"></i>
                </button>
              }
            </div>
          </article>
        }
      </div>
    </div>
  }
</div>
<div class="pagination-controls-wrapper" *ngIf="filteredDonors.length > 0">
  <div class="pagination-controls-row">
    <div class="pagination-stack">
      <div class="pagination-controls">
        <button
          class="pagination-button pagination-nav"
          (click)="setPage(currentPage - 1)"
          [disabled]="currentPage === 1"
        >
          <i class="bi bi-chevron-left"></i>
          Back
        </button>
        <ng-container *ngIf="totalPages > 1">
          <ng-container *ngFor="let item of paginationItems">
            <button
              *ngIf="item !== 'ellipsis'; else paginationEllipsis"
              class="pagination-button pagination-page"
              (click)="setPage(+item)"
              [class.active]="currentPage === item"
            >
              {{ item }}
            </button>
            <ng-template #paginationEllipsis>
              <span class="pagination-ellipsis">...</span>
            </ng-template>
          </ng-container>
        </ng-container>
        <button
          class="pagination-button pagination-nav"
          (click)="setPage(currentPage + 1)"
          [disabled]="currentPage === totalPages"
        >
          Next
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
      <div class="pagination-summary">
        {{ pageRangeStart }}-{{ pageRangeEnd }} of {{ filteredDonors.length }}
      </div>
    </div>

    <div class="page-size-controls">
      <label for="donor-table-page-size">Result per page</label>
      <select
        id="donor-table-page-size"
        class="form-select form-select-sm"
        [(ngModel)]="pageSize"
        (ngModelChange)="onPageSizeChange($event)"
      >
        <option *ngFor="let option of pageSizeOptions" [ngValue]="option">
          {{ option === 0 ? "All" : option }}
        </option>
      </select>
    </div>
  </div>
</div>
